<template>
  <div>
    <el-dropdown>
      <i class="el-icon-setting" style="margin-right: 15px"></i>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="exitHandler">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <span>admin</span>
  </div>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    exitHandler(){
      console.log('-----------------')
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>

</style>
